// Auto-update checker: controleert elke 60 seconden + bij tab-focus
// of er een nieuwe versie OF nieuwe content beschikbaar is en herlaadt automatisch.
// - buildTime  -> verandert bij elke frontend-deploy
// - dataVersion-> verandert bij elke content-wijziging in de DB (verhalen, covers, etc.)

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

let currentBuildTime = null;
let currentDataVersion = null;

async function checkForUpdate() {
  try {
    const t = Date.now();
    // Probeer eerst het dynamische /api/version (bevat ook data_version),
    // val terug op /version.json bij netwerkproblemen of oude backend.
    let buildTime = null;
    let dataVersion = null;
    try {
      const res = await fetch(`${API}/version?_t=${t}`, { cache: 'no-store' });
      if (res.ok) {
        const d = await res.json();
        buildTime = d.build_time || null;
        dataVersion = (typeof d.data_version === 'number') ? d.data_version : null;
      }
    } catch (_) { /* fall through */ }

    if (buildTime === null) {
      const res2 = await fetch(`/version.json?_t=${t}`, { cache: 'no-store' });
      if (!res2.ok) return;
      const d2 = await res2.json();
      buildTime = d2.buildTime || null;
    }

    // Eerste check: opslaan en wachten op volgende run
    if (currentBuildTime === null && currentDataVersion === null) {
      currentBuildTime = buildTime;
      currentDataVersion = dataVersion;
      return;
    }

    const buildChanged = buildTime !== null && buildTime !== currentBuildTime;
    const dataChanged = dataVersion !== null && currentDataVersion !== null && dataVersion !== currentDataVersion;

    if (buildChanged || dataChanged) {
      console.log('[AutoUpdate] Update gedetecteerd', { buildChanged, dataChanged, buildTime, dataVersion });
      performUpdate();
    } else {
      // Update referentiewaarden voor het geval ze net pas binnenkwamen
      if (currentDataVersion === null && dataVersion !== null) currentDataVersion = dataVersion;
      if (!currentBuildTime && buildTime) currentBuildTime = buildTime;
    }
  } catch (err) {
    // Netwerk offline of fout — negeer
  }
}

async function performUpdate() {
  try {
    // 1. SW caches wissen
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map(k => caches.delete(k)));
      console.log('[AutoUpdate] Caches gewist');
    }

    // 2. Service Worker deregistreren en opnieuw registreren
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (const reg of registrations) {
        // Stuur bericht om caches te wissen in SW
        if (reg.active) {
          reg.active.postMessage('CLEAR_CACHES');
        }
        await reg.unregister();
      }
      console.log('[AutoUpdate] Service Worker(s) gederegistreerd');
    }

    // 3. Pagina herladen — geen confirm() dialog
    console.log('[AutoUpdate] Pagina wordt herladen...');
    window.location.reload();
  } catch (err) {
    console.error('[AutoUpdate] Fout bij update:', err);
    // Probeer toch te herladen
    window.location.reload();
  }
}

export function initAutoUpdate() {
  // Check direct bij laden
  checkForUpdate();

  // Check elke 60 seconden
  setInterval(checkForUpdate, 60 * 1000);

  // Check bij terugkomen naar de tab
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      checkForUpdate();
    }
  });

  // Check bij focus op het venster
  window.addEventListener('focus', () => {
    checkForUpdate();
  });

  console.log('[AutoUpdate] Geïnitialiseerd — checkt elke 60s + bij tab-focus');
}
